
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advice/[slug]",
      function () {
        return require("private-next-pages/advice/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advice/[slug]"])
      });
    }
  